export default __webpack_public_path__ + "background.21767ceaf908424ba34bfd3eb855fc77.png";